import {createSlice} from '@reduxjs/toolkit';

const navigationSlice = createSlice({
    name: 'navigation',
    initialState: {
        sectionTitle: 'Capital',
    },
    reducers: {
        setSectionTitle: (state, action) => {
            state.sectionTitle = action.payload;
        },
    },
    selectors: {
        selectSectionTitle: (state) => state.sectionTitle,
    },
});

export const {setSectionTitle} = navigationSlice.actions;
export const {selectSectionTitle} = navigationSlice.selectors;
export const {reducer} = navigationSlice;